<template>
  <vuex-table :fields="fields" table_store="call-tracking/numbers/table">
    <template slot="actions" slot-scope="{ item }">
      <table-control type="trash" @click="remove(item)" />
    </template>
  </vuex-table>
</template>

<script>
  import { mapActions } from 'vuex';
  import { NumberModalService } from '@call-tracking/modals/NumberModalService';

  export default {
    computed: {
      fields: function() {
        return [
          {
            key: 'number',
            label: this.$t('call-tracking.number.field.number'),
            sortable: true,
            class: 'w-50'
          },
          {
            key: 'calltracking_status',
            label: this.$t('call-tracking.number.field.status'),
            sortable: true,
            class: 'w-25'
          },

          {
            key: 'calltracking_activated_at',
            label: this.$t('call-tracking.number.field.created_at'),
            sortable: true,
            class: 'table-created_at'
          },

          {
            key: 'actions',
            label: this.$t('shared.component.table.actions'),
            class: 'table-actions'
          }
        ];
      }
    },

    methods: {
      ...mapActions('call-tracking/numbers/table', ['getAsyncData']),

      remove: function(item) {
        NumberModalService.remove(item.id, item).on('success', () => this.getAsyncData());
      }
    }
  };
</script>

<style lang="scss"></style>
